module.exports = __webpack_public_path__ + "img/lock.5cfdaed1.jpg";